<template lang="pug">
  .main-container
    template(v-if="isFetching")
      v-skeleton-loader(type="article@3" class="my-10 mx-10")
    template(v-else-if="isError")
      .d-flex.justify-center.align-center.flex-column(style="height: 100dvh")
        v-icon(color="danger500") mdi-alert-circle-outline
        .text-sm.danger500--text.px-10.mt-2.text-center An error occurred while fetching data. Please try again later.
        v-btn.button-sm.mt-4.info500--text(color="info100" depressed :loading="isLoading" @click="handleRetry") Retry
    template(v-else)
      div.router-view-container
        router-view
      v-bottom-navigation(v-model="selectedPage" fixed grow height="72px" background-color="white")
        v-btn(v-for="navigation in navigationPages" :key="navigation.id" :value="navigation.id")
          span.pt-1 {{ navigation.text }}
          v-icon {{ navigation.icon }}
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex"
import {getAuth} from "@/utils";

export default {
  data() {
    return {
      selectedPage: null,
      isFetching: true,
      isError: false,
      isLoading: false,
      navigationPages: [
        {
          id: 'home',
          text: 'Home',
          icon: '$yzi-home-03'
        },
        // {
        //   id: 'pending',
        //   text: 'Pending',
        //   icon: '$yzi-users-03'
        // },
        {
          id: 'collect',
          text: 'Collect',
          icon: '$yzi-gift-02'
        },
        {
          id: 'you',
          text: 'You',
          icon: '$yzi-user-circle'
        }
      ]
    }
  },
  async mounted() {
    if (!this.user) {
      this.$router.push('/signin/merchant-app').catch(() => {
      })
      return
    }
    if (!this.company) {
      this.goToCompanyList()
      return
    }
    try {
      await this.fetchMember()
      const allFetching = [this.fetchGenes(), this.fetchSubscription(), this.fetchMemberPermission(), this.fetchLoyaltySettings(), this.fetchSettings()]
      await Promise.all([...allFetching])
      this.handleCheckSubscriptions()
      this.applySelectedPageWatcher()
      this.selectedPage = this.getPath()
      this.isFetching = false
    } catch (error) {
      this.isError = true
      this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
    } finally {
      this.isFetching = false
    }
  },
  computed: {
    ...mapState('user', ['user', 'member', 'deviceId']),
    ...mapState('subscriptions', ['genesData']),
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  methods: {
    ...mapActions(['showMessage']),
    applySelectedPageWatcher() {
      this.$watch('selectedPage', (value) => {
        this.$router.push(`/admin/marketing/merchant-app/${value}`).catch(() => {
        })
      })
    },
    getPath() {
      const pathArray = this.$route.path.split('/')
      const path = pathArray[pathArray.length - 1]
      const page = this.navigationPages.find(nav => nav.id === path)
      if (!page) {
        return this.navigationPages[0].id
      }
      return page.id
    },
    fetchLoyaltySettings() {
      return this.$axios.get(`/loyalty/${this.company.slug}`)
          .then(resp => {
            this.$store.commit('marketing/setLoyaltySettings', resp.data)
          })
    },
    fetchSettings() {
      return this.$axios.get(`/marketing/${this.company.slug}`)
          .then(resp => {
            this.$store.commit('marketing/setMarketingSettings', resp.data)
          })
    },
    fetchMember() {
      return this.$axios.get('/members/', {params: {user: this.user.id, company: this.company.id}})
          .then(resp => {
            if (resp.data.results.length === 0) {
              this.goToCompanyList()
            } else {
              this.$store.commit('user/setMember', resp.data.results[0])

              // Analytics
              if (this.deviceId) {
                this.$logEvent('company_session.started')
              }
            }
          })
    },
    goToCompanyList() {
      this.$router.push('/companies/merchant-app').catch(() => {
      })
    },
    fetchGenes() {
      return this.$axios.get(`/companies/${this.company.id}/genes`)
          .then((response) => {
            this.$store.commit('subscriptions/setLimitations', response.data)
            this.$store.commit('subscriptions/setGenes', response.data)
          })
    },
    fetchMemberPermission() {
      return this.$axios.get(`/members/${this.member.id}/permissions`)
          .then((response) => {
            const permissions = response.data
            this.$store.commit('permission/setPermissions', permissions)
          })
    },
    fetchSubscription() {
      return this.$axios.get(`/subscription/subscriptions/?company=${this.company.id}&terminated=false&ordering=start_date&expand=contract&page_size=1000`)
          .then((response) => {
            this.$store.commit('subscriptions/setSubscriptions', response.data.results)
            this.$store.commit('subscriptions/setDefaultFeature', this.company)
          })
    },
    handleCheckMarketingSubscription() {
      if (!getAuth('root', 'subscribe_marketing')) {
        this.$router.push('/no-subscription-warning').catch(() => {
        })
      }
    },
    handleAddingReviewTab() {
      if (getAuth('root', 'subscribe_review')) {
        this.navigationPages.splice(this.navigationPages.length - 1, 0 , {
          id: 'reviews',
          text: 'Reviews',
          icon: '$yzi-star-01',
        })
      }
    },
    handleCheckSubscriptions() {
      this.handleCheckMarketingSubscription()
      this.handleAddingReviewTab()
    },
    handleRetry() {
      this.isLoading = true
      window.location.reload()
    }
  },

}
</script>

<style scoped>
.router-view-container {
  overflow-y: auto !important;
}

.main-container {
  height: 100dvh;
}

.v-item-group.v-bottom-navigation .v-btn {
  font-size: 10px;
}

.v-btn:before {
  background-color: transparent;
}
</style>